import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Helmet } from 'react-helmet';

const LocalBusinessSchema = () => {
  const {
    datoCmsContactInformation: { phoneNumber, emailAddress },
  } = useStaticQuery(graphql`
    query LocalBusinessSchemaQuery {
      datoCmsContactInformation {
        phoneNumber
        emailAddress
      }
    }
  `);

  return (
    <Helmet
      script={[
        {
          type: 'application/ld+json',
          innerHTML: `{
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Display Wizard",
          "description": "Display Wizard are one of the UK's leading suppliers of display and exhibition products to use at events, trade shows and in retail environments. We specialise in the design, printing and distribution of a wide range of display stands. With years of experience in the industry and a vast knowledge across an array of sectors, we can provide you with high quality solutions to boost your marketing efforts.",
          "telephone": "${phoneNumber}",
          "email": "${emailAddress}",
          "address":{
            "@type": "PostalAddress",
            "addressLocality": "Preston",
            "addressRegion": "Lancashire",
            "streetAddress": "Units 15 & 16 Creamery Industrial Estate, Kenlis Road",
            "postalCode": "PR3 1GD"
          },
          "priceRange": "£0.70-32455",
          "url": "https://www.displaywizard.co.uk/"
        }`,
        },
      ]}
    />
  );
};

export default LocalBusinessSchema;
